import { downloadQr, getDashBoardData, getInActiveQrCount, getTicketDashboardData } from "../../../Http/Index";

export const getDailyBenData = async (tag: any, from: any, to: any) => {
  try {
    const res = await getDashBoardData(tag, from, to);
    // console.log("res:", res.data);
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getReqFieldFromObj = (obj: any, mandatoryField: any) => {
  let reqField: any = {};

  for (let key in obj) {
    if (mandatoryField.includes(key)) {
      reqField[key] = obj[key];
    }
  }
  // console.log("reqField:", reqField);
  return reqField;
};

export const tableSeparator = (data: any) => {
  // console.log(data)

  const getDetails = data?.relationship;
  // console.log("getDetails:", getDetails);
  let tableData: any = [];
  let total: any = {
    "S.No": 0,
    relationship: "-",
    totalUser: 0,
    activatedUser: 0,
    notActivatedUser: 0,
    address: 0,
    basicDetails: 0,
    emergencyContact: 0,
    insurancePolicies: 0,
    medicalInfo: 0,
    preferredHospital: 0,
    validNumber:0,
    notValidNumber:0,
    qrDispatched:0,
    qrNotDispatched:0
  };
  if (getDetails) {
    for (let i = 0; i < getDetails.length; i++) {
      let obj: any = {};
      const key: any = Object.keys(getDetails[i]);
      obj["S.No"] = i + 1;
      obj["relationship"] = key==="Self"?"Employee": key.join(",");
      obj["totalUser"] =
        getDetails[i][key]["activatedBeneficiary"] +
        getDetails[i][key]["notActivatedBeneficiary"];
      obj["activatedUser"] = getDetails[i][key]["activatedBeneficiary"];
      obj["notActivatedUser"] = getDetails[i][key]["notActivatedBeneficiary"];
      obj["address"] = getDetails[i][key]["address"];
      obj["basicDetails"] = getDetails[i][key]["basicDetails"];
      obj["emergencyContact"] = getDetails[i][key]["emergencyContact"];
      obj["insurancePolicies"] = getDetails[i][key]["insurancePolicies"];
      obj["medicalInfo"] = getDetails[i][key]["medicalInfo"];
      obj["preferredHospital"] = getDetails[i][key]["preferredHospital"];
      obj["qrDispatched"] = getDetails[i][key]["qrDispatched"];
      obj["qrNotDispatched"] = getDetails[i][key]["qrNotDispatched"];
      obj["validNumber"] = getDetails[i][key]["validNumber"];
      obj["notValidNumber"] = getDetails[i][key]["notValidNumber"];
      tableData.push(obj);
      total["S.No"]="--";
      total["totalUser"] += obj["totalUser"];
      total["activatedUser"] += obj["activatedUser"];
      total["notActivatedUser"] += obj["notActivatedUser"];
      total["address"] += obj["address"];
      total["basicDetails"] += obj["basicDetails"];
      total["emergencyContact"] += obj["emergencyContact"];
      total["insurancePolicies"] += obj["insurancePolicies"];
      total["medicalInfo"] += obj["medicalInfo"];
      total["preferredHospital"] += obj["preferredHospital"];
      total["qrDispatched"] += obj["qrDispatched"];
      total["qrNotDispatched"] += obj["qrNotDispatched"];
      total["validNumber"] += obj["validNumber"];
      total["notValidNumber"] += obj["notValidNumber"];
      
      // console.log('total:', total)
    }

    tableData.push(total);
    // console.log("total:", total);

    // console.log('tableData:', tableData);
    const mergedData=makeGroupByRelation(tableData);
    // console.log('mergedData:', mergedData);
    return {
      header: Object.keys(tableData[0]),
      benData: mergedData,
    };

  }
};

const makeGroupByRelation=(data:any)=>{
  const mergedData: Record<string, any> = {};
  
  data.forEach((row: any) => {
    const relation = row.relationship;
    const shouldMergeUnderOthers = [
      'brother',
      'sister',
      'grand father',
      'grand mother',
      'father-in-law',
      'mother-in-law',
      'others',
      'other',
      'friend',
      ''
    ].includes(relation?.toLowerCase());

    if(shouldMergeUnderOthers){
      if (mergedData['Others']) {
        includeValuesToExisting(mergedData,'Others',row);
      }else{
        row.relationship="Others"
        mergedData['Others'] = {...row};
      }
    }
    else{
      const isSon = relation.toLowerCase().startsWith('son');
      const isDaughter = relation.toLowerCase().startsWith('daughter');

      if(isSon){
        if (mergedData['Son']) {
          includeValuesToExisting(mergedData,'Son',row);
        }else{
          mergedData['Son'] = {...row};
        }
      }else if(isDaughter){
        if (mergedData['Daughter']) {
          includeValuesToExisting(mergedData,'Daughter',row);
        }else{
          mergedData['Daughter'] = {...row};
        }
      }else{
        mergedData[relation] = {...row};
      }    
    
    }
  });
  const getValues = Object.values(mergedData);
  return getValues;
}

const includeValuesToExisting = (mergedData: any,key: any, row: any) => {
  // console.log('row:', row,mergedData);
  if (mergedData[key]) {
      mergedData[key].notValidNumber += row?.notValidNumber;
      mergedData[key].totalUser += row.totalUser;
      mergedData[key].activatedUser += row.activatedUser;
      mergedData[key].notActivatedUser += row.notActivatedUser;
      mergedData[key].address += row.address;
      mergedData[key].basicDetails += row.basicDetails;
      mergedData[key].emergencyContact += row.emergencyContact;
      mergedData[key].insurancePolicies += row.insurancePolicies;
      mergedData[key].medicalInfo += row.medicalInfo;
      mergedData[key].preferredHospital += row.preferredHospital;
      mergedData[key].qrDispatched += row.qrDispatched;
      mergedData[key].qrNotDispatched += row.qrNotDispatched;
      mergedData[key].validNumber += row.validNumber;
  } else {
  }
  // console.log('mergedData:', mergedData);
}


export const getTicketData=async(queryParams:any)=>{
  try {
    const res=await getTicketDashboardData(queryParams);
    return res.data    
  } catch (error) {
    console.log('error:', error);    
  }
}

  export const buildQueries = (companyName:string) => {
    //if need filters?//as of now empty//
    return companyName = ""
  }
export const getQrCountDetails=async(queries:any)=>{
  try {
    const response = await getInActiveQrCount(queries);
    return response.data[0];
  } catch (err: any) {
    alert(err.data.response.message || "something Went wrong in finding active Qr");
    
  }
}


export const QrDownload=async(count:any)=>{
  try{
    const response = await downloadQr(count);
    return response;
  }catch(error:any){
    if (error.response && error.response.data instanceof Blob) {
      try {
        const text = await error.response.data.text(); // Convert Blob to text
        const json = JSON.parse(text); // Parse text to JSON
        // console.error("Error Message:", json.message); // Log the actual message
        alert(json?.message || "something Went wrong in the download Qr");
      } catch (parseError) {
        console.error("Could not parse error response:", parseError);
        alert(parseError || "something Went wrong in the download Qr");
      }
    } else {
      alert(error?.message || "something Went wrong in the download Qr");
    }
  }
}
